var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymHulliVeien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 2,
    cx: 11,
    cy: 18.8,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.26 7.4a6.5 6.5 0 00-6.46 6.45V14a6.51 6.51 0 006.43 6.45h.14a6.74 6.74 0 001.63-.27v-2.11l-.33.12a4.41 4.41 0 01-1.37.21 4.5 4.5 0 110-9 4.73 4.73 0 011.37.21l.33.12v-2.1a6.103 6.103 0 00-1.66-.23h-.08z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M9.2 4.9l3.15-.05-.54 7.01M13.61 7.92l9.03-1.04-2.43 8.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M14.22 8.66l4.98 7.94 4-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M20.79 3.23l5.8-1.54"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 11,
    cy: 18.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 29.3,
    cy: 13.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M4.01 23.91l-2.74-.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M1.5 27.5h3.52L6 30.51l6.01-1.03 1-1.98H30.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymHulliVeien);
export default __webpack_public_path__ + "static/media/BYM_HulliVeien.6004afcb.svg";
export { ForwardRef as ReactComponent };